module.exports = __webpack_public_path__ + "media/bootstrap-icons/mouse2-5f86057c.svg";